import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicComponentsModule } from "src/components/ionic-components.module";
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { EmptyStateComponent } from "src/components/general components/empty-state/empty-state.component";
import { PipesModule } from "src/pipes/pipes.module";
import { ListCalendarsSelectableComponent } from "./list-calendars/list-calendars.component";
import { ListEnvironmentsComponent } from "./list-environment/list-environments.component";
import { ListNotificationsSelectableComponent } from "./list-notifications/list-notifications.component";
import { GeneralComponentsModule } from "src/components/general components/general-components.module";
import { ListUsersComponent } from "./list-users/list-users.component";
@NgModule({
    declarations: [
        ListCalendarsSelectableComponent,
        ListNotificationsSelectableComponent,
        ListEnvironmentsComponent,
        ListUsersComponent
    ],
    imports: [
        EmptyStateComponent,
        CommonModule,
        FormsModule,
        IonicComponentsModule,
        TranslatePipe, TranslateDirective,
        PipesModule,
    ],
    exports: [
        ListCalendarsSelectableComponent,
        ListNotificationsSelectableComponent,
        ListEnvironmentsComponent,
        ListUsersComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

/**
 *
 *  Simone: List selectable module for import in page when you use a custom list selectable components
 *  When you add new list selectable component via ionic cli, you must:
 *  -  Import list selectable references in this module
 *  -  Put list selectable name (export name class) in declarations and exports array
 *
 *  Then you import ListSelectableModule in your desired page and put it into imports array of the module page
 *
 */
export class ListSelectableModule { }
